<template>
  <div>
    <section class="content-header">
      <h1>{{ item && item['name'] }}</h1>
    </section>

    <section class="content">
      <div class="box box-primary">
        <div class="box-body">      <item-show-errors :entity="'currency'" :is-loading="isLoading"></item-show-errors>

            <div v-if="item" class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th width="20%">{{$t('field')}}</th>
                  <th>{{$t('value')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{$t('currency.name')}}</td>
                  <td>{{ item['name'] }}</td>
                </tr>
                <tr>
                  <td>{{$t('currency.code')}}</td>
                  <td>{{ item['code'] }}</td>
                </tr>
                <tr>
                  <td>{{$t('currency.createdAt')}}</td>
                  <td>{{ moment(item['createdAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('currency.updatedAt')}}</td>
                  <td>{{ moment(item['updatedAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('currency.updatedBy')}}</td>
                  <td>{{ item['updatedBy'] }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      <item-show-actions :item="item" :entity="'Currency'" :path="'currency'"></item-show-actions>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'

export default {
  components: {ItemShowErrors, ItemShowActions },
  data () {
    return {
      moment: moment
    }
  },
  computed: mapGetters({
    isLoading: 'currency/show/isLoading',
    item: 'currency/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      reset: 'currency/show/reset',
      retrieve: 'currency/show/retrieve'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/currency/Show.vue